import { Briefcase, MapPin, Layers } from "lucide-react";
import { cn } from "../../../../../../../lib/utils";

const fieldConfig = {
    job: {
        icon: Briefcase,
        color: "text-violet-500",
        bg: "bg-violet-50",
    },
    location: {
        icon: MapPin,
        color: "text-emerald-500",
        bg: "bg-emerald-50",
    },
    org: {
        icon: Layers,
        color: "text-sky-500",
        bg: "bg-sky-50",
    },
} as const;

type FieldType = keyof typeof fieldConfig;

interface SettingValue {
    id: string;
    code: string;
    description: string;
}

interface SettingCellProps {
    value?: SettingValue | null;
    field: string;
}

function resolveField(field: string): FieldType {
    if (field === "job") return "job";
    if (field === "location") return "location";
    return "org";
}

function SettingCell({ value, field }: SettingCellProps) {
    const { icon: Icon, color, bg } = fieldConfig[resolveField(field)];

    return value ? (
        <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-w-full">
            <div className={cn("tw-flex tw-items-center tw-justify-center tw-rounded-md tw-p-1.5 tw-shrink-0", bg)}>
                <Icon size={13} className={color} />
            </div>
            <div className="tw-flex tw-flex-col tw-min-w-0">
                <span className="tw-text-xs tw-font-semibold tw-text-neutral-700 tw-truncate tw-leading-tight">{value.code}</span>
                <span className="tw-text-xs tw-text-neutral-400 tw-truncate tw-leading-tight">{value.description}</span>
            </div>
        </div>
    ) : null;
}

export default SettingCell;
